import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getVisitorDetails } from "../Actions/VisitorManagement";
import logo from "../Asset/download.jpg";
import API from "../helpers/api";
import axios from "axios";
import { getVisitorSearchList } from "../Actions/VisitorManagement";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import swal from "sweetalert";
import { toast } from "react-toastify";
import Moment from "moment";
import Role from "../helpers/role";


let searchData = {
  shipId: 0,
  PageNumber: 1,
  isPass: false,
  showAllResult: true,
  PageSize: 25,
  shipName: "",
  fromDate: "",
  toDate: "",
};

let userRole = localStorage.getItem("UserRoles");

class VisitorManagementDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      visitorData: {
        visitorId: "",
        shipName: "",
        result: "",
        reading: "",
        photo: "",
        photoName: "",
      },
    };
    this.DeleteVisitor = this.DeleteVisitor.bind(this);
  }

  componentDidMount() {
    const { match, dispatch } = this.props;
    const { params } = match;
    const { id } = params;
    dispatch(getVisitorDetails(id));
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    const { dispatch, visitorDetail } = nextProps;
    if (visitorDetail && visitorDetail !== "") {
      prevState.visitorData.visitorId = visitorDetail.visitorId;
      prevState.visitorData.shipName = visitorDetail.shipName;
      prevState.visitorData.result = visitorDetail.result;
      prevState.visitorData.reading = visitorDetail.reading;
      prevState.visitorData.photo = visitorDetail.photo;
      if (visitorDetail.photoName !== null) {
        prevState.visitorData.photoName = visitorDetail.photoName;
      }
    }
  }

  componentDidUpdate() {
    window.onpopstate = (e) => {
      this.setState({ showSidePane: false });
      this.props.dispatch({ type: "ShowSidePan", data: false });
    };
  }
  ShowSidePanel = () => {
    this.setState({ showSidePane: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.goBack();
  };

  render() {
    const { visitorDetail } = this.props;
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row pt-4 pb-3"> </div>
          <div className="row pt-3">
            <div className="col-lg-12">
              <div className="resource-list-auth-date">
                <div className="panel-box search-filter-box">
                  <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                    onClick={() => this.ShowSidePanel()}
                  >
                    <div style={{ position: 'relative' }}>
                      <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Return</span>
                    </div>
                  </button>
                  <div
                    className="card mt-2 MM-card-header"
                    style={{ backgroundColor: "white" }}
                  >
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1a3464",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title m-2"
                        style={{ color: "092a51" }}
                      >
                        Visitor Details
                      </h5>
                    </div>
                    <div className="pt-3 pb-3 search-filter-box">
                      <div className="row">
                        <div className="col-sm-2 m-auto text-right">
                          <div className="text-center rounded-circle">
                            <img
                              src={
                                visitorDetail && visitorDetail.photo
                                  ? visitorDetail.photo
                                  : logo
                              }
                              alt="Smiley face"
                              height="70px !important"
                              style={{ width: "90%" }}
                              class="rounded-circle"
                            ></img>
                          </div>
                        </div>
                        <div className="col-sm-10">
                          <div className="row">
                            <div className="col-sm-12">
                              <label className="form-label">Ship Name :</label>
                              <span>
                                {" "}
                                {visitorDetail ? visitorDetail?.shipName : ""}
                              </span>
                            </div>

                            <div className="col-sm-6">
                              <label className="form-label">Reading :</label>
                              <span>
                                {" "}
                                {visitorDetail ? visitorDetail?.reading : ""}
                              </span>
                            </div>

                            <div className="col-sm-6">
                              <label className="form-label">Result :</label>
                              <span>
                                {" "}
                                {visitorDetail &&
                                  visitorDetail?.reading === "Refuse"
                                  ? "-"
                                  : visitorDetail?.result
                                    ? "Fail"
                                    : "Pass"}
                              </span>
                            </div>
                            <div className="col-sm-12">
                              <label className="form-label">Date :</label>
                              <span>
                                {" "}
                                {visitorDetail ? Moment(new Date(Date.parse(visitorDetail.dateTime))).format('DD-MM-YYYY h:mm' + " " + "UTC") : ""}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 pb-2 pt-2">
                      <div
                        className="search-btn-col mt-1"
                        style={{ textAlign: "right" }}
                      >
                        {userRole == Role.mmpl ? (<>
                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                            type="button"
                            onClick={() => this.ShowSidePanel()}
                          >
                            {" "}
                            Cancel{" "}
                          </button>
                        </>) : (<>
                          <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                            type="submit"
                            onClick={() => this.EditVisitorDetails(visitorDetail)}
                          >
                            {" "}
                            Edit{" "}
                          </button>
                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                            type="button"
                            onClick={() =>
                              this.DeleteVisitor(visitorDetail.visitorId)
                            }
                          >
                            {" "}
                            Delete{" "}
                          </button>
                        </>)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  EditVisitorDetails(item) {
    const { dispatch, history } = this.props;
    dispatch({ type: "VisitorUserDetails", data: item });
    this.props.history.push(`/Home/Management/EditVisitor/${item.visitorId}`);
    dispatch({ type: "ShowSidePan", data: false });
  }
  DeleteVisitor = (id, crew) => {
    const { dispatch } = this.props;
    dispatch({ type: "ShowShipName", data: true });
    confirmAlert({
      message: "Are you sure want to delete?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            let url = `${API.UpdateVisitor}?crewMemberId=${crew ?? 0
              }&VisitorId=${id}&IsDeleted=${true}`;
            axios
              .put(url)
              .then((response) => {
                if (response?.status === 200) {
                  this.ShowSidePanel();
                  dispatch(getVisitorSearchList(searchData, 1));
                  toast.success("Visitor Deleted Successfully", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                  dispatch({ type: "ShowShipName", data: false });
                }
              })
              .catch((error) => {
                swal("Error!", "Something went wrong. Please try again.", "warning");
                console.log("Error in Update Crew" + error);
              });
          },
        },
        {
          label: "No",
          onClick: () => {
            dispatch({ type: "ShowShipName", data: false });
          },
        },
      ],
      overlayClassName: 'custom-alert'
    });
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    visitorDetail: state.VisitorManagementReducer.visitorDetail,
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(VisitorManagementDetail)
);
